import React from 'react';
import Intro from '../components/project-single-intro';
import Rows from '../components/project-single-rows';
import Footer from '../components/project-single-footer';
import ProjectsGrid from '../components/projects-grid';

function ProjectSingle(props) {
  return (
    <div>
      <Intro {...props.node} />
      <Rows {...props.node} />
      <Footer {...props.node} />
      <ProjectsGrid nodes={props.nodes} controls={true} />
    </div>
  );
}

export default ProjectSingle;
